import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postArticleDiscount } from "../../app/services/articleDiscountService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";

import Form from "react-bootstrap/Form";
import { Alert, Breadcrumb, Button, Col, Row } from "react-bootstrap";
import {
  ArticleDiscount,
  defaultArticleDiscount,
} from "../../models/responses/articleDiscount";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface Props {}

const ArticleDiscountAdd: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [displayError, setDisplayError] = useState(false);
  const isWaitingArticleDiscountPostResponse = useSelector(
    (state: RootState) =>
      state.articleDiscount.isWaitingArticleDiscountPostResponse,
  );

  const [articleDiscountData, setArticleDiscountData] =
    useState<ArticleDiscount>(defaultArticleDiscount);

  const handleAddArticleDiscount = () => {
    setDisplayError(false);
    dispatch(
      postArticleDiscount(
        instance,
        account,
        articleDiscountData,
        onSuccess,
      ),
    );
  };

  const onSuccess = (articleDiscountId: string | null) => {
    if (articleDiscountId === null) {
      setDisplayError(true);
      return;
    }

    setTimeout(() => {
      navigate(`../${articleDiscountId}`, { relative: "path" });
    }, 500);
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/article-discounts">
          Artikelrabatter
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Ny artikelrabatt</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form className="w-3">
        <Row>
          <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Artikel ID (ADID)</Form.Label>
                <Form.Control
                  type="text"
                  value={articleDiscountData.externalId}
                  onInput={(e) =>
                    setArticleDiscountData({
                      ...articleDiscountData,
                      externalId: e.currentTarget.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Namn *</Form.Label>
              <Form.Control
                type="text"
                value={articleDiscountData.name}
                onInput={(e) =>
                  setArticleDiscountData({
                    ...articleDiscountData,
                    name: e.currentTarget.value,
                  })
                }
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Beskrivning *</Form.Label>
              <Form.Control
                type="text"
                value={articleDiscountData.description}
                onInput={(e) =>
                  setArticleDiscountData({
                    ...articleDiscountData,
                    description: e.currentTarget.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Rabatt %</Form.Label>
                <Form.Control
                  type="number"
                  value={articleDiscountData.discountPercentage}
                  onInput={(e) =>
                    setArticleDiscountData({
                      ...articleDiscountData,
                      discountPercentage: Number(e.currentTarget.value),
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Fastpris</Form.Label>
                <Form.Control
                  type="text"
                  value={articleDiscountData.forcedSalesPrice ?? ""}
                  onInput={(e) =>
                    setArticleDiscountData({
                      ...articleDiscountData,
                      forcedSalesPrice: e.currentTarget.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </Row>

        <div className="text-end">
          <Button
            variant="primary"
            className="mb-3"
            onClick={handleAddArticleDiscount}
            disabled={
              !(
                articleDiscountData.name !== undefined &&
                articleDiscountData.name.length > 0 &&
                articleDiscountData.description !== undefined &&
                articleDiscountData.description.length > 0 &&
                articleDiscountData.discountPercentage !== undefined &&
                articleDiscountData.discountPercentage >= 0 &&
                !isWaitingArticleDiscountPostResponse
              )
            }
          >
            Lägg till artikelrabatt
          </Button>
        </div>

        <Alert key="alert" variant="danger" show={displayError}>
          <p>Något gick fel, kontrollera uppgifterna och försök igen.</p>
        </Alert>
      </Form>
    </div>
  );
};

export default ArticleDiscountAdd;
